"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CarFrontSolid.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CarFrontSolid = function CarFrontSolid(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "solid-icon",
    viewBox: "0 0 240.54 199.3"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Car Front Icon"), _react2.default.createElement("path", {
    className: "car",
    d: "M240.54 110.7a31.58 31.58 0 0 0-3-13.38c-.19-1.06-.43-2.1-.7-3.16l-20.9-51.78-.15-.47C208.49 20.14 198.08 0 171.7 0H70.86c-27 0-36.58 20.64-44 41.8L5 93.69a32 32 0 0 0-5 17v16.11a31.29 31.29 0 0 0 .85 7.28 12.64 12.64 0 0 0-.85 4.57v47.93a12.71 12.71 0 0 0 12.72 12.72h26.41a12.72 12.72 0 0 0 12.72-12.72v-24H190.2v24a12.71 12.71 0 0 0 12.72 12.72h24.9a12.71 12.71 0 0 0 12.72-12.72v-47.93a12.72 12.72 0 0 0-.85-4.55 31.5 31.5 0 0 0 .85-7.28V110.7zM42.31 47c8.32-23.46 15-30.64 28.55-30.64H171.7c13.44 0 20.91 8 28.51 30.54l15.25 30.9a46.67 46.67 0 0 0-16.21-2.87H41.3a47.09 47.09 0 0 0-14.7 2.34zm13.1 86H27.55a9.09 9.09 0 0 1 0-18.19h27.86a9.09 9.09 0 0 1 0 18.19zm98.43-1.83H89a5.75 5.75 0 0 1 0-11.51h64.81a5.75 5.75 0 0 1 0 11.51zm58.44 1.83h-27.86a9.09 9.09 0 0 1 0-18.19h27.86a9.09 9.09 0 0 1 0 18.19zm0 0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = CarFrontSolid;